/* Dynamic Plot code copyright 2017 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Numerical Decimal places selection component, allow user to override
 * decimal places for the current attribute.
 */

import React from "react";
import { decimalPoints } from "../../../utils/constants";
import IncrDecrInput from "../../common/IncrDecrInput.jsx";
import ToolTip from "../../common/ToolTip.js";
import Toggle from "react-toggle";

class NumericDecimalsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // value: this.props.attributeObj.stats.isNumeric() ? "numerical" : "categorical"
            // To support the subtype along with datatype of the attribute
            value: this.props.attributeObj.getNumericDecimals(),
            hasTrailingZeros: this.props.attributeObj.hasTrailingZeros(),
        };
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    handleChangeNumericDecimals = (value) => {
        this.setState(
            {
                value,
            },
            this.props.handleChange( {
                filterChanged: true,
                dataType: "numerical",
                component: "numeric-decimals",
                numericDecimals: Number( value ),
            } )
        )
    }

    handleChangeTrailingZeros = (e, option) => {
        this.setState(
            {
                hasTrailingZeros: e.target.checked,
            },
            this.props.handleChange( {
                dataType: "numerical",
                component: "numeric-decimals",
                hasTrailingZeros: Boolean( e.target.checked ),
            } )
        )
    };

    render = () => {
        return (
            <div
                className={
                    "tde-numeric-component tde-mt-3 tde-mb-4 tde-row" +
                    (this.props.reduceCaseCardWidth
                        ? " tde-px-2"
                        : " tde-px-3")
                }
            >
                <div className="tde-label tde-mb-2">
                    { this.getLoc( "Decimals" ) }
                    <ToolTip
                        tip={ this.getLoc(
                            "Increase or decrease decimal places"
                        ) }
                        Dyn={ this.props.Dyn }
                        dir="r"
                    >
                        <i role="button" className="tde-i tde-i-help tde-ml-1"
                            aria-label={ this.getLoc( "Increase or decrease decimal places" ) }>
                            <span className="tde-sr-only">{ this.getLoc( "Help" ) }</span>
                        </i>
                    </ToolTip>
                </div>
                <IncrDecrInput
                    label={ "Decimals" }
                    getLoc={ this.getLoc }
                    value={ this.state.value }
                    onChange={ ( value ) => {
                        this.handleChangeNumericDecimals( value );
                    } }
                    options={ decimalPoints }
                />
                <div className="tde-d-flex tde-mt-3 tde-justify-space-between">
                    <label className="text-normal" htmlFor="tde-numeric-trailing-zeros-toggle">
                        <span className="flex-1">
                            { this.getLoc( "Trailing Zeros" ) }
                            <ToolTip tip={
                                this.getLoc( "Show trailing zeros in the Case Card and Table View" ) }
                                Dyn={ this.props.Dyn }
                                dir="r"
                            >
                                <i className="tde-i tde-i-help tde-ml-1"
                                   aria-label={ this.getLoc( "Show trailing zeros in the Case Card and Table View" ) }>
                                    <span className="tde-sr-only">{ this.getLoc( "Help" ) }</span>
                                </i>
                            </ToolTip>
                        </span>
                    </label>
                    <Toggle
                        aria-label={`${this.getLoc( "Trailing Zeros" )}, ${this.state.hasTrailingZeros ? 'checked' : 'unchecked'}, checkbox`}
                        className="black-toggle"
                        id="tde-numeric-trailing-zeros-toggle"
                        checked={ this.state.hasTrailingZeros }
                        icons={ false }
                        onChange={ ( e ) => {
                            this.handleChangeTrailingZeros( e );
                        } }
                    />
                </div>
            </div>
        );
    };
}

export default NumericDecimalsComponent;
